<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      title="关于我们"
      left-arrow
      z-index="10"
      @click-left="goableBack()"></van-nav-bar>
    <div class="content-bg">
      <div>
        <div class="logo-bg">
          <img src="../../assets/img/share/share.jpg" alt="logo" fit="cover" />
        </div>
        <div class="version">当前版本：{{ version }}</div>
        <div class="tel-bg">
          <img
            src="../../assets/img/options/icon-dart.png"
            alt="tel"
            fit="cover" />
          <a class="tel-title" href="tel:400-694-0070">40069-40070</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "aboutus",
  components: {},
  data() {
    return {
      version: process.env.VUE_APP_VERSION
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  background-color: white;
  min-height: calc(100vh - 45px);
}
.content-bg {
  background-color: white;
  justify-content: center;
  display: flex;
  align-items: center;
  .logo-bg {
    text-align: center;
  }
  .logo-bg img {
    margin-top: 2rem;
    width: 70px;
    height: 70px;
  }
  .version {
    font-size: 17px;
    color: rgb(46, 46, 46);
    margin-top: 20px;
    margin-bottom: 40px;
    text-align: center;
  }
  .tel-bg {
    display: flex;
    height: 40px;
    border-radius: 20px;
    border: 1px solid rgb(119, 119, 119);
    align-items: center;
    margin-bottom: 30px;
    img {
      margin-left: 15px;
      width: 30px;
      height: 30px;
    }
    .tel-title {
      margin: 0 20px 0 15px;
      font-size: 17px;
      font-weight: 500;
      color: rgb(119, 119, 119);
    }
  }
}
</style>
